// extracted by mini-css-extract-plugin
export default {"curatorCard":"styles_curatorCard__0pglN","curatorImg":"styles_curatorImg__-GUP0","nickName":"styles_nickName__bb8SS","hashtags":"styles_hashtags__Ykbm3","tag":"styles_tag__-g0G2"};